var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Companies","icon":"mdi-home","loading-message":_vm.loadingMessage,"show-loading":_vm.isShowLoading,"error-message":_vm.errorMessage,"show-error":_vm.isShowError}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.tableHeaders,"items":_vm.tableItems,"items-per-page":40},on:{"click:row":_vm.clickRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }